import { useMainContext } from "../../components/main-context";
import { useMedia } from 'react-use';
var useMediaWithDevice = function useMediaWithDevice(query, trueForDevice, defaultState) {
  var _useMainContext = useMainContext(),
    device = _useMainContext.device;
  return useMedia(query, defaultState !== null && defaultState !== void 0 ? defaultState : device === trueForDevice);
};
export default useMediaWithDevice;